import {
    DomainInitPayload,
    PaymentMethod,
} from '@sxm-de/dev-kits/web-sdk/types';
import { getDefaultPaymentMethod } from '../helpers/get-default-payment-method';

export type GetDefaultPaymentMethodFn = () => Promise<PaymentMethod>;

export function initGetDefaultPaymentMethodFn({
    dependencies,
}: DomainInitPayload): GetDefaultPaymentMethodFn {
    return async () => {
        return await getDefaultPaymentMethod(dependencies);
    };
}
